module.exports = __webpack_public_path__ + "static/media/green_tick_mark.4eaa6302.svg";